<div class="table-toolbar">
  <div class="toolbar-actions">
    <app-toolbar>
      <!-- Primary Save Button -->
      <button mat-raised-button 
              color="primary" 
              class="toolbar-btn toolbar-btn--primary"
              matTooltip="Save"
              [disabled]="!isFormValid() || isProcessing()" 
              (click)="onSubmit()">
        <mat-icon svgIcon="save" />
        <span>Save</span>
      </button>

      <!-- Secondary Save & Close Button -->
      <button mat-stroked-button 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Save and Close"
              [disabled]="!isFormValid() || isProcessing()" 
              (click)="onSubmit(true)">
        <mat-icon svgIcon="save" />
        <span>Save & Close</span>
      </button>

      <button mat-stroked-button
              class="toolbar-btn toolbar-btn--export"
              matTooltip="Export report"
              [disabled]="!general()?.id || isProcessing() || isExporting()"
              [matMenuTriggerFor]="exportMenu">
        @if (isExporting()) {
        <mat-spinner diameter="16" strokeWidth="3" class="toolbar-btn__spinner" />
        }
        @if (!isExporting()) {
        <mat-icon>download</mat-icon>
        }
        <span>{{ isExporting() ? 'Exporting...' : 'Export as' }}</span>
        
      </button>

      <mat-menu #exportMenu="matMenu" xPosition="after" yPosition="below">
        <button mat-menu-item (click)="exportReport(ExportFormat.Excel)" [disabled]="isExporting()">
          <mat-icon>table_view</mat-icon>
          <span>Excel</span>
        </button>
        <button mat-menu-item (click)="exportReport(ExportFormat.Word)" [disabled]="isExporting()">
          <mat-icon>description</mat-icon>
          <span>Word</span>
        </button>
        <button mat-menu-item (click)="exportReport(ExportFormat.Pdf)" [disabled]="isExporting()">
          <mat-icon>picture_as_pdf</mat-icon>
          <span>Pdf</span>
        </button>
      </mat-menu>
      
      <div class="toolbar-separator"></div>

      <!-- Workflow Action Buttons (Secondary Style) -->
      @if (buttonScripts.reportTypeChange()) {
      <button mat-stroked-button 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Change Report Type"
              [disabled]="isProcessing()" 
              (click)="changeReportType()">
        <mat-icon>swap_horiz</mat-icon>
        <span>Change Report Type</span>
      </button>
      }

      @if (buttonScripts.draftForReview()) {
      <button mat-stroked-button 
              id="DraftedForReview" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Send Draft for Review"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.DraftedForReview)">
        <mat-icon>send</mat-icon>
        <span>Send Draft for Review</span>
      </button>
      }

      @if (buttonScripts.submitForSrOps()) {
      <button mat-stroked-button 
              id="SubmittedToOpsAdvisor" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Submit to Operations Advisor"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.SubmittedToOpsAdvisor)">
        <mat-icon>send</mat-icon>
        <span>Submit to Operations Advisor</span>
      </button>
      }

      @if (buttonScripts.planConfirmed()) {
      <button mat-stroked-button 
              id="PlanConfirmed" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Plan confirmed"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.PlanConfirmed)">
        <mat-icon>fact_check</mat-icon>
        <span>Plan confirmed</span>
      </button>
      }

      @if (buttonScripts.requestRIPT()) {
      <button mat-stroked-button 
              id="RequestRIPT" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Request RIPT"
              [disabled]="isDisabled()" 
              (click)="requestRIPT()">
        <mat-icon>request_page</mat-icon>
        <span>Request RIPT</span>
      </button>
      }

      @if (buttonScripts.riskEvaluationScored()) {
      <button mat-stroked-button 
              id="RiskEvaluationScored" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Risk Evaluation Scored"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.RiskEvaluationScored)">
        <mat-icon>analytics</mat-icon>
        <span>Risk Evaluation Scored</span>
      </button>
      }

      @if (buttonScripts.riptScored()) {
      <button mat-stroked-button 
              id="RIPTScored" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="RIPT scored"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.RIPTScored)">
        <mat-icon>grading</mat-icon>
        <span>RIPT scored</span>
      </button>
      }

      @if (buttonScripts.planEndorsed()) {
      <button mat-stroked-button 
              id="PlanEndorsed" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Plan Endorsed"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.PlanEndorsed)">
        <mat-icon>verified</mat-icon>
        <span>Plan Endorsed</span>
      </button>
      }

      @if (buttonScripts.planApproved()) {
      <button mat-stroked-button 
              id="PlanApproved" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Plan Approved"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.PlanApproved)">
        <mat-icon>approval</mat-icon>
        <span>Plan Approved</span>
      </button>
      }

      @if (buttonScripts.v_n_vCompleted()) {
      <button mat-raised-button 
              id="ValidationAndVerificationCompleted" 
              class="toolbar-btn toolbar-btn--success"
              matTooltip="V & V completed"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.ValidationAndVerificationCompleted)">
        <mat-icon>check_circle</mat-icon>
        <span>V & V completed</span>
      </button>
      }

      @if (buttonScripts.closed()) {
      <button mat-raised-button 
              id="Closed" 
              class="toolbar-btn toolbar-btn--success"
              matTooltip="Closed"
              [disabled]="isDisabled()" 
              (click)="changeApprovalFlowState(ApprovalState.Closed)">
        <mat-icon>done_all</mat-icon>
        <span>Close</span>
      </button>
      }

      @if (buttonScripts.recycle()) {
      <button mat-stroked-button 
              id="Recycle" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Recycle"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.Recycle)">
        <mat-icon>recycling</mat-icon>
        <span>Recycle</span>
      </button>
      }

      @if (buttonScripts.outOfService()) {
      <button mat-stroked-button 
              id="OutOfService" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Out of Service"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.OutOfService)">
        <mat-icon>block</mat-icon>
        <span>Out of Service</span>
      </button>
      }

      @if (buttonScripts.reactivate()) {
      <button mat-raised-button 
              id="Reactivate" 
              class="toolbar-btn toolbar-btn--success"
              matTooltip="Reactivate"
              [disabled]="isProcessing()"
              (click)="reactivateReport()">
        <mat-icon>restore</mat-icon>
        <span>Reactivate</span>
      </button>
      }

      @if (buttonScripts.updateRIPT()) {
      <button mat-stroked-button 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Update RIPT"
              [disabled]="isDisabled()" 
              (click)="updateRIPT()">
        <mat-icon>update</mat-icon>
        <span>Update RIPT</span>
      </button>
      }

      @if (buttonScripts.cancelled()) {
      <button mat-stroked-button 
              id="Cancelled" 
              class="toolbar-btn toolbar-btn--secondary"
              matTooltip="Cancel"
              [disabled]="isDisabled()"
              (click)="changeApprovalFlowState(ApprovalState.Cancelled)">
        <mat-icon>cancel</mat-icon>
        <span>Cancel</span>
      </button>
      }
    </app-toolbar>
  </div>
</div>

<app-action-required />

<mat-card class="card-toolbar" [class.have-highlight]="highlightedField()">
  <mat-card-content>
    @if (general()?.id) {
    <div class="report-info">
      @if (general()?.reportTitleEn; as reportTitleEn) {
      <div class="report-name">
        <span class="report-title">{{ reportTitleEn }}</span>
        <span class="secondary">FIRM Deviation Management</span>
      </div>
      }

      <div class="report-details">
        @if (general()?.uniqueId; as uniqueId) {
        <div class="report-unique-id">
          <span class="primary">{{ uniqueId }}</span>
          <span class="secondary">ID</span>
        </div>
        <mat-divider [vertical]="true" />
        }

        @if (riskScore().value) {
        <div class="report-unique-id">
          <span class="primary">{{ riskScore().value ?? '---' }}</span>
          <span class="secondary">{{ riskScore().label }}</span>
        </div>
        <mat-divider [vertical]="true" />
        }

        @if (approvalStep(); as approvalStep) {
        <div class="report-status">
          <span class="primary">{{ approvalStep | appApprovalStatusNaming }}</span>
          <span class="secondary">Status</span>
        </div>
        <mat-divider [vertical]="true" />
        }

        @if (general()?.owner; as owner) {
        <div class="report-owner">
          <span class="owner-name primary">{{ owner }}</span>
          <span class="secondary">Report owner</span>
        </div>
        }
      </div>
    </div>
    } @else {
    <div class="report-info">
      <div class="report-name">
        <span class="report-title">New FIRM Deviation Management</span>
      </div>
    </div>
    }

    <div class="report-steps">
      <span class="report-steps__title">FDM Lifecycle</span>
      @if (general()?.id) {
      <button mat-icon-button
              class="report-steps__refresh-btn"
              matTooltip="Refresh lifecycle state"
              [disabled]="isRefreshing()"
              (click)="onRefreshCurrentState()">
        @if (isRefreshing()) {
          <mat-spinner diameter="16" />
        } @else {
          <mat-icon>refresh</mat-icon>
        }
      </button>
      }
      @for (stage of approvalFlowSteps(); track stage; let idx = $index, e = $even, last = $last) {
      <div class="{{ idx < approvalFlowSteps().length - 1 ? 'status-step' : 'last-status-step' }}">
        <p [class]="isTerminalState() ? (approvalStepIndex() === idx ? 'initiative-status' : 'inactive-initiative-status') : (approvalStepIndex() < idx ? 'inactive-initiative-status' : 'initiative-status')">
          <mat-icon svgIcon="clickCheck2"></mat-icon>{{ stage | appApprovalStepNaming }}
        </p>
      </div>
      @if (!last) {
      /
      }
      }
    </div>
  </mat-card-content>
</mat-card>


<mat-tab-group class="report-tabs" [class.have-highlight]="highlightedField()" [selectedIndex]="tabIdx" (selectedIndexChange)="pageChange($event)" animationDuration="0ms">
  
  <mat-tab label="General" class="container-fluid" [labelClass]="getTabClass(ReportFormPage.GENERAL)">
    <app-general-tab />
  </mat-tab>

  @if (showFormState()) {
  <mat-tab label="Equipment" class="container-fluid " [labelClass]="getTabClass(ReportFormPage.EQUIPMENTS)">
    <app-equipment-tab />
  </mat-tab>
 

  @if (showFindingDescription()) {
  <mat-tab label="Finding Description" class="container-fluid " [labelClass]="getTabClass(ReportFormPage.FINDING_DESCRIPTION)">
    <app-finding-description-tab />
  </mat-tab>
  }

  @if (showRiskEvaluation()) {
  <mat-tab label="Risk Evaluation" class="container-fluid" [labelClass]="getTabClass(ReportFormPage.RISK_EVALUATION)">
    <app-risk-evaluation />
  </mat-tab>
  }

  @if (showRIPT()) {
  <mat-tab label="RIPT" class="container-fluid" [labelClass]="getTabClass(ReportFormPage.RIPT)">
    <app-ript-tab />
  </mat-tab>
  }

  <mat-tab label="Mitigation & Resolution Plan" class="container-fluid" [labelClass]="getTabClass(ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN)">
    <app-mitigation-resolution-tab />
  </mat-tab>

  <mat-tab label="Approval Flow" class="container-fluid" [labelClass]="getTabClass(ReportFormPage.APPROVAL_FLOW)">
    <app-approval-flow-tab />
  </mat-tab>

  <mat-tab label="Notes & Attachment" class="container-fluid">
    <app-note-attachment-tab />
  </mat-tab>

  <mat-tab label="Audit History" class="container-fluid">
    <app-audit-history />
  </mat-tab>
  }
</mat-tab-group>

@if (isProcessing()) {
<div class="loading-overlay">
  <div class="loading-container">
    <mat-spinner class="main" diameter="60"></mat-spinner>
    <p class="loading-text">Processing...</p>
  </div>
</div>
}
